import { EPaidProductType, EProductType } from '../type'

import type { TProduct } from '../type'

function doesProductNameContainKeywords(
  productName: string,
  keywords: string[],
): boolean {
  const lowerProductName = productName.toLocaleLowerCase()
  return keywords.some((keyword) =>
    lowerProductName.includes(keyword.toLocaleLowerCase()),
  )
}

function getProductTypeFromKeywords(
  productName: string,
): EPaidProductType | EProductType {
  if (
    doesProductNameContainKeywords(productName, ['basic', 'standard', 'plus'])
  ) {
    return EPaidProductType.BASIC
  } else if (doesProductNameContainKeywords(productName, ['pro'])) {
    return EPaidProductType.PRO
  } else if (doesProductNameContainKeywords(productName, ['unlimited'])) {
    return EPaidProductType.UNLIMITED
  } else if (doesProductNameContainKeywords(productName, ['ultimate'])) {
    return EPaidProductType.ULTIMATE
  } else if (doesProductNameContainKeywords(productName, ['free'])) {
    return EProductType.FREE
  }
  return EProductType.FREE
}

export function getProductType({
  product,
}: {
  product: Pick<TProduct, 'productName'>
}): EPaidProductType | EProductType {
  const productName = product?.productName || ''
  return getProductTypeFromKeywords(productName)
}

export function getPaidProductType({
  product,
}: {
  product: Pick<TProduct, 'productName'>
}): EPaidProductType {
  const productName = product?.productName || ''
  const productType = getProductTypeFromKeywords(productName)
  return productType !== EProductType.FREE
    ? (productType as EPaidProductType)
    : EPaidProductType.PRO
}
